import { isBefore, startOfDay } from "date-fns";

interface UseCalendarPermissionsProps {
  today: Date;
  canClickBlockedDates: boolean;
  canClickBookedDates: boolean;
  canClickFutureDates: boolean;
  canClickPastDates: boolean;
  isDayBooked: (day: Date, propertyId: string) => boolean;
  isDateManuallyBlocked: (date: Date, propertyId: string) => boolean;
}

const useCalendarPermissions = ({
  today,
  canClickBlockedDates,
  canClickBookedDates,
  canClickFutureDates,
  canClickPastDates,
  isDayBooked,
  isDateManuallyBlocked,
}: UseCalendarPermissionsProps) => {
  const isBeforeToday = (date: Date) => isBefore(date, startOfDay(today));

  return (day: Date, propertyId: string) => {
    const isPast = isBeforeToday(day);
    const isBlocked = isDateManuallyBlocked(day, propertyId);
    const isBooked = isDayBooked(day, propertyId);

    const canClick =
      (isPast && canClickPastDates) ||
      (isBlocked && canClickBlockedDates) ||
      (isBooked && canClickBookedDates) ||
      (!isPast && !isBlocked && !isBooked && canClickFutureDates);

    return { isPast, isBlocked, isBooked, canClick };
  };
};

export default useCalendarPermissions;
